export default __webpack_public_path__ + "static/blob8-cdce27809329f3bd54939679c9b0459c.svg";